import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const data = [
  { name: 'Jan', projects: 7, actuals: 15, amt: 30 },
  { name: 'Feb', projects: 5, actuals: 21, amt: 30 },
  { name: 'Mar', projects: 9, actuals: 20, amt: 20 },
  { name: 'Apr', projects: 4, actuals: 16, amt: 20 },
  { name: 'May', projects: 7, actuals: 21, amt: 21 },
  { name: 'Jun', projects: 3, actuals: 14, amt: 25 },
];

const BarChartCard = () => {
  return (
    <div className='w-[430px] h-[200px]'>
      <ResponsiveContainer className="flex" width="100%" height="100%">
        <BarChart
          data={data}
          barSize={20}
          margin={{
            top: 20,
            right: 30,
            left: 0,
            bottom: 5,
          }}
        >
          <CartesianGrid vertical={false} />
          <XAxis dataKey="name" tickLine={false} />
          <YAxis className='text-sm'
            axisLine={false}
            tickLine={false}
            domain={[0, 30]}
            ticks={[0, 10, 20, 30]}
            tickFormatter={(value) => `${value}M`}
          />
          <Tooltip />
          <Bar dataKey="actuals" stackId="a" fill="#a8c5da" />
          <Bar dataKey="projects" stackId="a" fill="#d0dfeb" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default BarChartCard;
